import {Component} from '@angular/core';

@Component({
  selector: 'fax-ico',
  templateUrl: './fax-ico.component.html'
})
export class FaxIcoComponent {
}
